import rolesRouter from './roles/router'
import aclEntitiesRouter from './aclEntities/router'

export default [
  ...rolesRouter,
  ...aclEntitiesRouter,
]
